import ScreenLayout from '@/layouts/mainLayout'
const tabRoutes = [
  {
    path: '/',
    name: '首页',
    component: () => import('@/pages/home/index'),
    // meta: {
    //   title: '首页',
    // },
  },
  {
    path: '/notice',
    name: '通知公告',
    component: () => import('@/pages/notice/index'),
    // meta: {
    //   title: '通知公告',
    // },
  },
  {
    path: '/guideline',
    name: '使用指南',
    component: () => import('@/pages/guideline/index'),
    // meta: {
    //   title: '使用指南',
    // },
  },
  {
    path: '/question',
    name: '常见问题',
    component: () => import('@/pages/questions/index'),
    // meta: {
    //   title: '常见问题',
    // },
  },
  {
    path: '/about',
    name: '关于我们',
    component: () => import('@/pages/about/index'),
    // meta: {
    //   title: '关于我们',
    // },
  },
  {
    path: '/notice/detail',
    name: '通知公告详情',
    component: () => import('@/pages/notice/detail'),
    // meta: {
    //   title: '通知公告详情',
    // },
  },
  {
    path: '/search',
    name: '搜索',
    component: () => import('@/pages/search/index'),
  },
]
const options = {
  routes: [
    {
      path: '/',
      name: '首页',
      redirect: '/',
      component: ScreenLayout,
      children: tabRoutes,
      meta: {
        title: '首页',
      },
    },
  ],
}
export { tabRoutes, options }
